module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./AfterSaleClauseView.js"));
	}, "AfterSaleClauseView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleClauseView!./src/pages/Shop/Member/Agreements/AfterSaleClause/AfterSaleClauseView.js
// module id = 948
// module chunks = 438